module.exports = __webpack_public_path__ + "img/emails.dfde9f2c.svg";